import seguimiento from './seguimiento';
import maestros from './maestros';
import administracion from './administracion';
import gestion from './gestion';

const menuItems = auth => {
    return {
        items: [seguimiento, maestros, gestion, administracion]
    };
};

const applyPermissions = auth => {
    const items = menuItems(auth);

    return items;
};

export const createMenuItems = auth => {
    if (!auth.user) return null;
    return applyPermissions(auth);
};
